import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { getRouteLogin } from 'shared/constants/routerConst';
import useAuth from 'shared/hooks/useAuth';
import { Loader } from 'shared/ui/Loader';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { authenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <Loader />
      </Box>
    );
  }

  if (!authenticated) {
    return <Navigate to={getRouteLogin()} replace />;
  }

  return <>{children}</>;
}
